
import { useEffect } from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastProvider,
  ToastViewport,
} from "@/components/ui/toast"
import { ToastTitle, ToastDescription } from "@/components/ui/typography"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  // Add a global click handler to dismiss all toasts when clicking outside
  useEffect(() => {
    const handleGlobalClick = (e: MouseEvent) => {
      // Don't dismiss if clicking inside a toast
      const isToastClick = (e.target as HTMLElement)?.closest('[role="status"]');
      const isToastCloseClick = (e.target as HTMLElement)?.closest('[toast-close]');
      const isToastButtonClick = (e.target as HTMLElement)?.closest('button');
      const isToastActionButton = (e.target as HTMLElement)?.closest('[data-toast-action="true"]');
      const isTextSelection = window.getSelection()?.toString() !== '';
      
      // Don't dismiss toast if text is being selected
      if (isTextSelection) {
        return;
      }
      
      // Dismiss if it's a toast action button
      if (isToastActionButton) {
        dismiss();
        return;
      }
      
      // Only dismiss if click is outside toasts and not on a toast close button or internal button
      if (!isToastClick && !isToastCloseClick && !isToastButtonClick) {
        dismiss();
      }
    };

    document.addEventListener("click", handleGlobalClick);
    return () => document.removeEventListener("click", handleGlobalClick);
  }, [dismiss]);

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1 select-text">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
